import { styled } from '@mui/material';
import Dialog from '@mui/material/Dialog';

export const TransportWithCustomWeightDiffDialogStyledContainer = styled(Dialog)`
  .close-button {
    position: absolute;
    top: 8px;
    right: 8px;
  }
`;

export const TransportWithCustomWeightDiffStyledContainer = styled('section')`
  padding: 30px;
  gap: 24px;
  display: flex;
  flex-flow: column;
  width: 100%;

  .controls-wrapper {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .continue-search-btn {
    color: #fff;
  }
`;
